import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BreadcrumbsModule } from "src/app/components/elementi-strutturali/breadcrumbs/breadcrumbs.module";
import { ContactsModule } from "src/app/components/elementi-strutturali/contacts/contacts.module";
import { MapModule } from "src/app/components/elementi-strutturali/map/map.module";
import { ActionsListComponent } from "src/app/shared/components/actions-list/actions-list.component";
import { SocialShareComponent } from "src/app/shared/components/social-share/social-share.component";
import { PlaceLayoutComponent } from "./place-layout.component";

@NgModule({
  imports: [CommonModule, BreadcrumbsModule, FormsModule, RouterModule, MapModule, SocialShareComponent, ActionsListComponent, ContactsModule],
  declarations: [PlaceLayoutComponent],
  exports: [PlaceLayoutComponent],

})
export class PlaceLayoutModule {
  static component = PlaceLayoutComponent
}